import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { AdminLayout } from "../../components/admin/AdminLayout";
import { StatusBadge } from "../../components/StatusBadge";

export default function AdminCustomers() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  useEffect(() => { document.title = "Customers | Sambiva Admin"; }, []);
  const { data: customers = [] } = useQuery({ queryKey: ["admin-customers", status], queryFn: async () => (await api.get(`/admin/customers${status ? `?status=${status}` : ""}`)).data });

  return (
    <AdminLayout title="Customers">
      <div className="flex gap-2 mb-5">
        {["", "Approved", "Pending", "Rejected"].map((s) => (
          <button key={s} data-testid={`cust-filter-${s || "all"}`} onClick={() => setStatus(s)} className={`text-sm px-4 py-2 rounded-full font-medium ${status === s ? "bg-sambiva-green text-white" : "bg-white border border-black/10 text-sambiva-charcoal"}`}>{s || "All"}</button>
        ))}
      </div>
      <div className="bg-white rounded-2xl border border-black/5 overflow-x-auto">
        <table className="w-full text-sm min-w-[820px]">
          <thead className="bg-[#f6f7f9] text-sambiva-muted text-left">
            <tr><th className="px-4 py-3 font-semibold">Company</th><th className="px-4 py-3 font-semibold">Contact</th><th className="px-4 py-3 font-semibold">Email</th><th className="px-4 py-3 font-semibold">Country</th><th className="px-4 py-3 font-semibold">Type</th><th className="px-4 py-3 font-semibold">Status</th><th className="px-4 py-3 font-semibold">Created</th></tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id} data-testid={`customer-row-${c.id}`} onClick={() => navigate(`/admin/customers/${c.id}`)} className="border-t border-black/5 hover:bg-sambiva-cream/30 cursor-pointer">
                <td className="px-4 py-3 font-medium text-sambiva-charcoal">{c.company_name}</td>
                <td className="px-4 py-3 text-sambiva-muted">{c.contact_name}</td>
                <td className="px-4 py-3 text-sambiva-muted">{c.email}</td>
                <td className="px-4 py-3 text-sambiva-muted">{c.country}</td>
                <td className="px-4 py-3 text-sambiva-muted">{c.business_type}</td>
                <td className="px-4 py-3"><StatusBadge status={c.status} /></td>
                <td className="px-4 py-3 text-sambiva-muted">{new Date(c.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {customers.length === 0 && <div className="p-10 text-center text-sambiva-muted">No customers found.</div>}
      </div>
    </AdminLayout>
  );
}
